import { useDevice } from '@/hooks';

export interface DeviceWrapperProps extends React.PropsWithChildren {
  show: ('desktop' | 'mobile')[]
}

export function DeviceWrapper({ show, children }: DeviceWrapperProps) {
  const { isDesktop, isMobile } = useDevice();

  if ((isDesktop() && show.includes('desktop')) ||
    (isMobile() && show.includes('mobile')))
    return <>{children}</>;
  return null;
}

export default DeviceWrapper;
